/**
 * Two state disconnector for Lublin
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Discon extends Element {
  get radius () {
    return (this.elementTypeName === 'Discon_feeder') ? 16 : 20
  }

  setDefaultShapes () {
    const radius = this.radius

    if (['Discon', 'Discon2', 'Discon_feeder'].includes(this.elementTypeName)) {
      this.shapes = [
        new Ren.Circle({
          name: 'circle',
          x: 0,
          y: 0,
          radius,
          fill: Color.offlineGray
        }),
        new Ren.Line({
          name: 'aspectOff',
          points: [-radius / 2, 0, radius / 2, 0],
          lineCap: 'butt',
          visible: false
        }),
        new Ren.Line({
          name: 'aspectOn',
          points: [0, -radius, 0, radius],
          lineCap: 'butt',
          visible: false
        }),
        new Ren.Circle({
          name: 'dot',
          type: 'Circle',
          x: 0,
          y: 0,
          radius: radius / 4,
          fill: 'black',
          stroke: 'black',
          visible: false
        }),
        new Ren.Circle({
          name: 'onlineStatus',
          x: -radius,
          y: -radius,
          radius: 3,
          opacity: 1,
          fill: 'red'
        })
      ]
    } else if (this.elementTypeName === 'Sect_isol') {
      this.shapes.push(
        new Ren.Circle({
          name: 'circle_sect_isol',
          x: 0,
          y: 0,
          radius: radius,
          fill: 'white'
        }),
        new Ren.Line({
          points: [-radius / 2, -radius / 6, radius / 2, -radius / 6],
          lineCap: 'butt',
          strokeWidth: 2
        }),
        new Ren.Line({
          points: [-radius / 2, radius / 6, radius / 2, radius / 6],
          lineCap: 'butt',
          strokeWidth: 2
        })
      )
    }
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)

    // variable: position
    if (status.position === 1) {
      this.modifyShape('dot', 'visible', true)
      this.modifyShape('aspectOn', 'visible', false)
      this.modifyShape('aspectOff', 'visible', false)
    } else if (status.position === 0) {
      this.modifyShape('circle', 'fill', 'green')
      this.modifyShape('aspectOff', 'visible', true)
      this.modifyShape('aspectOn', 'visible', false)
      this.modifyShape('dot', 'visible', false)
    } else if (status.position === 2) {
      this.modifyShape('circle', 'fill', 'red')
      this.modifyShape('aspectOn', 'visible', true)
      this.modifyShape('aspectOff', 'visible', false)
      this.modifyShape('dot', 'visible', false)
    } else if (status.positionOff === 1) {
      this.modifyShape('circle', 'fill', 'green')
      this.modifyShape('aspectOff', 'visible', true)
      this.modifyShape('aspectOn', 'visible', false)
      this.modifyShape('dot', 'visible', false)
    } else if (status.positionOn === 1) {
      this.modifyShape('circle', 'fill', 'red')
      this.modifyShape('aspectOn', 'visible', true)
      this.modifyShape('aspectOff', 'visible', false)
      this.modifyShape('dot', 'visible', false)
    } else if (status.intermediatePosition === 1) {
      this.modifyShape('dot', 'visible', true)
      this.modifyShape('aspectOff', 'visible', false)
      this.modifyShape('aspectOn', 'visible', false)
    } else {
      this.modifyShape('dot', 'visible', false)
      this.modifyShape('aspectOff', 'visible', false)
      this.modifyShape('aspectOn', 'visible', false)
    }
  }
}
